
        <h4>Modello riordino</h4>
        <dx-data-grid
            id="gridContainer"
            [dataSource]="dataSource"
            [showBorders]="true"
            [focusedRowEnabled]="false"
            [columnAutoWidth]="true"
            [columnHidingEnabled]="true"
            [showColumnLines]="true"
            [showRowLines]="true"
            [rowAlternationEnabled]="true"
            (onRowUpdating)="onUpdating($event)"
            >

            <dxo-editing
                mode="row"
                [allowAdding]="true"
                [allowUpdating]="true"
                [allowDeleting] ="true"
                [useIcons]="true"
            >
            <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
            </dxo-editing>

            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxi-column type="buttons" [buttons]="['edit', 'delete']"></dxi-column>
            <dxi-column
                dataField="idTipologia"
                caption="Tipo Articolo"
                >
                <dxo-lookup [dataSource]="listTipiArticoli" valueExpr="id" displayExpr="descrizione">
                    
                </dxo-lookup>
            </dxi-column>
            <dxi-column
                dataField="qta"
                dataType="number">
            </dxi-column> 
            <dxi-column
                dataField="note">
            </dxi-column> 
              

                 </dx-data-grid>